export default "__VITE_ASSET__Bk46Zw0W__"